let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jVok0")).then(() => parcelRequire('d3cjG'));